import script from "./IFRSAssets.vue?vue&type=script&setup=true&lang=js"
export * from "./IFRSAssets.vue?vue&type=script&setup=true&lang=js"

import "./IFRSAssets.vue?vue&type=style&index=0&id=870e2ad0&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-870e2ad0"]])

export default __exports__